/* Painel: indicadores do ano, participação por escopo, evolução mensal, obras e fornecedores. */

import { api } from '../core/api';
import { cat, state } from '../core/estado';
import { esc, lista, nf, num, pct } from '../core/formato';
import type { Mes, PorFornecedor, PorObra, Resumo } from '../tipos/api';
import { carregar } from '../ui/carregar';
import { kpi, legendaEscopos, loading, vazio } from '../ui/componentes';
import { setHtml } from '../ui/dom';
import { paramsFiltro, filtrosBar } from '../ui/filtros';
import { barrasEmpilhadas, barrasEscopo, barrasH, donut } from '../ui/graficos';
import type { Pagina } from './pagina';

export const painel: Pagina = {
  render: () => `
  <div class="row" style="margin-bottom:18px"><h1 class="page" style="margin:0">${esc(cat().empresa.nome || 'Inventário')}</h1></div>
  ${filtrosBar()}
  <div class="grid g4" id="pKpis" style="margin-bottom:16px">${[1, 2, 3, 4].map(() => `<div class="card">${loading()}</div>`).join('')}</div>
  <div class="grid" style="grid-template-columns:minmax(0,320px) minmax(0,1fr);align-items:start">
    <div class="card">
      <div class="kpi-title" style="margin-bottom:16px">Participação por escopo</div>
      <div id="pDonut">${loading()}</div>
    </div>
    <div class="card">
      <div class="kpi-head"><div class="kpi-title">Emissões mensais por escopo — ${esc(state.f.ano)}</div><span class="pill grey">tCO₂e</span></div>
      ${legendaEscopos()}
      <div id="pMensal">${loading()}</div>
    </div>
  </div>
  <div class="grid g2" style="margin-top:16px;align-items:start">
    <div class="card">
      <div class="between" style="margin-bottom:14px"><h2 class="sec" style="margin:0">Maiores obras emissoras</h2>
        <a class="btn btn-plain no-print" href="#/analise/obras">Ver todas</a></div>
      <div id="pObras">${loading()}</div>
    </div>
    <div class="card">
      <div class="between" style="margin-bottom:14px"><h2 class="sec" style="margin:0">Maiores fornecedores emissores</h2>
        <a class="btn btn-plain no-print" href="#/analise/fornecedores">Ver análise</a></div>
      <div id="pForn">${loading()}</div>
    </div>
  </div>`,

  carregar(tk) {
    const params = paramsFiltro({ escopo: undefined });
    carregar(tk, [
      {
        id: 'pKpis', tambem: ['pDonut'],
        busca: () => api<Resumo>('GET', '/resumo', { params }),
        html: (d: Resumo) => {
          setHtml('pDonut', `<div style="display:flex;justify-content:center;margin-bottom:16px">${donut([
            { l: 'Escopo 1', v: num(d.escopo_1), c: 'var(--esc1)' },
            { l: 'Escopo 2', v: num(d.escopo_2_total), c: 'var(--esc2)' },
            { l: 'Escopo 3', v: num(d.escopo_3), c: 'var(--esc3)' },
          ])}</div>${legendaEscopos('margin:0;gap:10px 18px')}`);
          return kpi('Emissões totais', nf(d.emissao_total), 'tCO₂e', `${nf(d.total_linhas, 0)} lançamentos calculados em ${esc(d.ano ?? state.f.ano)}`)
            + kpi('Escopo 1 — diretas', nf(d.escopo_1), 'tCO₂e', `${pct(d.escopo_1, d.emissao_total)} do total · combustíveis e gases`)
            + kpi('Escopo 2 — energia', nf(d.escopo_2_total), 'tCO₂e', `${pct(d.escopo_2_total, d.emissao_total)} do total · energia da rede`)
            + kpi('Escopo 3 — cadeia de valor', nf(d.escopo_3), 'tCO₂e', `${pct(d.escopo_3, d.emissao_total)} do total · materiais e fretes`);
        },
      },
      {
        id: 'pMensal',
        busca: () => api<Mes[]>('GET', '/mensal', { params }),
        html: (d: Mes[]) => {
          const meses = lista<Mes>(d);
          return meses.some((m) => num(m.total_emissoes)) ? barrasEscopo(meses.map((m) => [num(m.escopo_1), num(m.escopo_2), num(m.escopo_3)])) : vazio();
        },
      },
      {
        id: 'pObras',
        busca: () => api<PorObra[]>('GET', '/por-obra', { params }),
        html: (d: PorObra[]) => barrasEmpilhadas(lista<PorObra>(d).slice(0, 5).map((u) => ({
          l: u.unidade_negocio || 'Sem obra informada', v: [u.escopo_1, u.escopo_2, u.escopo_3].map(num),
        }))),
      },
      {
        id: 'pForn',
        busca: () => api<PorFornecedor[]>('GET', '/por-fornecedor', { params }),
        html: (d: PorFornecedor[]) => barrasH(lista<PorFornecedor>(d).map((f) => ({ l: f.nome_fornecedor || 'Sem fornecedor', v: num(f.total_emissoes), c: 'var(--esc3)' }))),
      },
    ]);
  },
};
